import { render } from "./MainCanvas.vue?vue&type=template&id=6773ab8d"
import script from "./MainCanvas.vue?vue&type=script&lang=js"
export * from "./MainCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__